<template>
    <div class="land-video">
        <div class="container">
            <div class="section-title">
                <h2>{{salesCard.video_section_title}}</h2>
            </div>
            <div class="video-items" :class="{'one-item' : salesCard.video_items.length == 1, 'two-items' : salesCard.video_items.length == 2, 'more-items' : salesCard.video_items.length >= 3}">
                <div class="video-item" v-for="item in salesCard.video_items">
                    <a href="#" class="link-open-modal" @click.prevent="openVideoModal(item.video_link)">
                        <div class="video-icon">
                            <svgIcon name="play" />
                        </div>
                        <div class="video-item-img" :style="'background-image:url(' + item.video_preview + ')'"></div>
                    </a>
                </div>
            </div>
        </div>
        <modal name="video-modal" 
            @before-close="beforeVideoModalClose" 
            @closed="videoModalClosed" 
            :transition="transitionName" 
            :width="modalWidth" 
            :height="modalHeight" 
            :scrollable="modalScrollable"  
            class="video-item-modal"               
            id="video-modal">
            <div class="modal-content" v-if="modalData.link != null">
                <div class="video-player">
                    <iframe :src="modalData.link + '?autoplay=1&loop=1&rel=0&showinfo=0&vq=highres&color=white&iv_load_policy=3'" frameborder="0" allow="autoplay" allowfullscreen></iframe>
                </div>
                <button class="close-link" @click.prevent="closeVideoModal">
                    <svgIcon name="close"/>
                </button>
            </div>
        </modal>
    </div>   
</template>

<script>
    import svgIcon from '@/components/partials/SvgIcon.vue';
    import {mapGetters} from 'vuex'
    export default {
        name: 'sale-land-video',
        components: {
            svgIcon,
        },
        data () {
            return {
                modalWidth: 1000,
                modalHeight: 'auto',
                modalScrollable: false,
                modalData: {
                    // date: null,
                    // title: null,
                    link: null
                },
                transitionName: 'pop-out',
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            openVideoModal(link) {
                // this.modalData.date = date;
                // this.modalData.title = title;
                this.modalData.link = link;
                this.$modal.show('video-modal');
                document.getElementsByTagName('body')[0].classList.add('video_open');
            },
            closeVideoModal() {
                this.$modal.hide('video-modal');
                document.getElementsByTagName('body')[0].classList.remove('video_open');
            },
            beforeVideoModalClose() {
                document.getElementsByTagName('body')[0].classList.remove('video_open');
            },
            videoModalClosed() {
                document.getElementsByTagName('body')[0].classList.remove('video_open');
            }
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/land-video.scss';
    //  @import '@/styles/respond/sales/sales-land-partials/land-video-respond.scss';
</style>